'use client';

import dynamic from 'next/dynamic';

export const Loadbee = dynamic(
  () => import(/* webpackChunkName: 'Loadbee' */ './Loadbee.client').then((mod) => mod.Loadbee),
  {
    ssr: false,
  },
);
